import { useMemo } from 'react';
import { useTimeoutFn } from 'react-use';

import dayjs from '@didaskill/services/dayjs';

const MAX_TIMEOUT = 2147483647; // Maximum value for setTimeout in milliseconds

/**
 * Hook used to exec a function after date.
 *
 * @param date - The date observed to exec the function after.
 * @param func - The function to be executed.
 * @returns See the documentation of useTimeoutFn.
 */
export const useExecAt = (date: string | Date | undefined, func: () => any) => {
  const diffms = useMemo(() => dayjs(date).diff(dayjs()), [date]);

  return useTimeoutFn(func, diffms > MAX_TIMEOUT ? MAX_TIMEOUT : diffms);
};
